import React from "react";
import { Link } from "react-router-dom";
import { getLocalDate } from "utils/helpers";

interface ISpecialOfferProps {
  id: number;
  name: string;
  description: number;
  date_begin: string;
  date_end: string;
  top_discount_pct: number;
  top_agent_fee_pct: number;
}

const SpecialOffer: React.SFC<ISpecialOfferProps> = ({ ...props }) => {
  return (
    <div className="card_desc_">
      <Link to={`/home/catalog/page/0?offer=${props.id}`}>
        <h2>{props.name}</h2>
        <div className="offer-description">{props.description}</div>
        <div>
          <div className="data___dd_">
            {getLocalDate(props.date_begin, "DD.MM.YYYY")} —{" "}
            {getLocalDate(props.date_end, "DD.MM.YYYY")}
          </div>
          <div className="ref__btn btn w_100__ special-offer-btn">
            Посмотреть
          </div>
        </div>
      </Link>
    </div>
  );
};

export default SpecialOffer;
